import { superGrids, SuperGridType } from '@/superGrids.ts';

export const isSuperGrid = (gridId: string) => {
  const superGridIds = Object.keys(superGrids).map((key) => {
    return superGrids[key as SuperGridType].grid.toUpperCase();
  });
  return superGridIds.includes(gridId.toUpperCase());
};
